export default "__VITE_ASSET__BEQzXKIq__"